module.exports = __webpack_public_path__ + "static/media/DSCF9885.8e3b20b0.jpg";